import { PageHero } from "@/components/site/PageHero";
import { COMPANY } from "@/config/site";
import { usePageMeta } from "@/hooks/usePageMeta";

const UPDATED = "22 October 2026";
const contactLine = COMPANY.contact.email ? `at ${COMPANY.contact.email}` : "through the enquiry form on our Contact page";

const LegalBody = ({ sections, testId }) => (
  <section className="pb-24 md:pb-32" data-testid={testId}>
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <p className="eyebrow lg:col-span-3">Last updated: {UPDATED}</p>
      <div className="lg:col-span-8 space-y-12">
        {sections.map(([h, ps]) => (
          <div key={h} className="border-t hairline pt-8">
            <h2 className="font-display text-2xl md:text-3xl">{h}</h2>
            {ps.map((p, i) => <p key={i} className="mt-4 max-w-2xl leading-relaxed text-[var(--ink-2)]">{p}</p>)}
          </div>
        ))}
      </div>
    </div>
  </section>
);

const privacy = [
  ["Who we are", [`This website is operated by ${COMPANY.name}. This policy explains how we handle personal information submitted through this website.`]],
  ["Information we collect", ["When you submit an enquiry, we collect the details you provide: your name, company name, business email, phone number, enquiry type, brand of interest and message.", "We do not run online sales on this website and do not collect payment information."]],
  ["How we use it", ["We use your information only to review and respond to your enquiry, and to keep a record of business communications. We do not sell your personal information."]],
  ["Storage and security", ["Enquiries are stored on secured servers with access limited to authorised personnel. We retain enquiries only as long as needed for the purposes described here or as required by law."]],
  ["Your choices", [`You may request access to, correction of, or deletion of your personal information by contacting us ${contactLine}.`]],
  ["Changes", ["We may update this policy from time to time. The latest version will always be available on this page."]],
];

const terms = [
  ["Use of this website", [`This website provides corporate information about ${COMPANY.name} and its brands. By using it, you agree to these terms.`]],
  ["No online sales", ["This website does not sell products or accept orders. Brand websites linked from this site are governed by their own terms and policies."]],
  ["Intellectual property", ["The Suvirika name, logo, brand names and site content are the property of their respective owners and may not be used without prior written permission."]],
  ["External links", ["Links to other websites are provided for convenience. We are not responsible for the content or practices of external websites."]],
  ["Accuracy of information", ["We aim to keep information current and accurate but do not guarantee that all content is complete or up to date at all times."]],
  ["Contact", [`Questions about these terms can be sent ${contactLine}.`]],
];

export const Privacy = () => {
  usePageMeta("Privacy Policy", "How Suvirika Retail Pvt Ltd handles personal information submitted through this website.");
  return (
    <>
      <PageHero eyebrow="Legal" lines={["Privacy Policy"]} testId="privacy-hero" />
      <LegalBody sections={privacy} testId="privacy-body" />
    </>
  );
};

export const Terms = () => {
  usePageMeta("Terms of Use", "Terms governing the use of the Suvirika Retail Pvt Ltd corporate website.");
  return (
    <>
      <PageHero eyebrow="Legal" lines={["Terms of Use"]} testId="terms-hero" />
      <LegalBody sections={terms} testId="terms-body" />
    </>
  );
};
